import CustomApiError from "./CustomApiError"

export default class ServerError extends CustomApiError {
  message = "Internal server error."
}
